export default "__VITE_ASSET__29193bcf__"